// Anything larger than the most common laptop screen
// 1366px - USE SPARINGLY. `MIDLARGE` is our most common
// "largest" breakpoint
export const MQ_XLARGE = '(min-width: 85.375rem)';
// Sizes smaller than the largest laptop screens
export const MQ_MIDLARGE_DOWN = '(max-width: 85.374rem)';
// Sizes larger than landscape tablets (essentially laptop screens)
export const MQ_MIDLARGE = '(min-width: 75rem)';
// Sizes smaller than our our laptop screen breakpoint
export const MQ_LARGE_DOWN = '(max-width: 74.99rem)';
// iPad landscape and up
export const MQ_LARGE = '(min-width: 64rem)';
// Sizes from the largest tablet on down
export const MQ_MEDIUM_DOWN = '(max-width: 63.99rem)';
// iPad portrait
export const MQ_MEDIUM = '(min-width: 48rem)';
// landscape smart phones
export const MQ_PHONE_LANDSCAPE = '(min-width: 36rem)';
// recipe box left rail
export const LEFT_RAIL_LARGE = '(min-width: 1236px)'; // 976px + [130 (button width) * 2]
export const LEFT_RAIL_MIDLARGE = '(min-width: 1408px)'; // 1148px + [130 (button width) * 2]

// Ranges
export const MQ_PHONE_ONLY = '(max-width: 35.99rem)';
export const MQ_SMALL_ONLY = '(max-width: 47.99rem)';
export const MQ_MEDIUM_ONLY = '(min-width: 48rem) and (max-width: 63.99rem)';
export const MQ_LARGE_ONLY = '(min-width: 64rem) and (max-width: 74.99rem)';
export const MQ_MIDLARGE_ONLY = '(min-width: 75rem) and (max-width: 85.374rem)';
